import {Component, Input} from '@angular/core';

@Component({
    selector: 'color-filter',
    templateUrl: 'color-filter.html',
    styleUrls: ['color-filter.scss'],
})
export class ColorFilter {

  @Input() public id: string;
  @Input() public color: string;

  public get matrix(): string {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    this.color = this.color.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r: string, g: string, b: string): string => {
      return r + r + g + g + b + b;
    });

    const result: RegExpExecArray = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.color);
    if (result) {
      const r: number = parseInt(result[1], 16) / 255;
      const g: number = parseInt(result[2], 16) / 255;
      const b: number = parseInt(result[3], 16) / 255;

      return '0 0 0 0 ' + r + ' 0 0 0 0 ' + g + ' 0 0 0 0 ' + b + ' 0 0 0 1 0';
    }

    return '';
  }

}
